import type { App } from 'vue'
import { hasRole } from './permission/hasRole'
import { hasPermi } from './permission/hasPermi'

export const setupAuth = (app: App<Element>) => {
    hasRole(app)
    hasPermi(app)
}